import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MultiStepForm } from './components/MultiStepForm';
import { RecaptchaProvider } from './components/RecaptchaProvider';
import { AdminPortal } from './pages/AdminPortal';
import { NetworkOnboardingForm } from './pages/NetworkOnboardingForm';
import { SuccessPage } from './pages/SuccessPage';
import { useAnalytics } from './hooks/useAnalytics';

function AppContent() {
  // Initialize analytics and track page views automatically
  useAnalytics();

  return (
    <Routes>
      {/* Root redirect to first step */}
      <Route path="/" element={<Navigate to="/signup/personal-info" replace />} />

      {/* Customer-facing signup form with step-based routes */}
      <Route path="/signup" element={<Navigate to="/signup/personal-info" replace />} />
      <Route path="/signup/personal-info" element={
        <div className="min-h-screen bg-white">
          <MultiStepForm />
        </div>
      } />
      <Route path="/signup/contact-info" element={
        <div className="min-h-screen bg-white">
          <MultiStepForm />
        </div>
      } />
      <Route path="/signup/fca-number" element={
        <div className="min-h-screen bg-white">
          <MultiStepForm />
        </div>
      } />
      <Route path="/signup/business-info" element={
        <div className="min-h-screen bg-white">
          <MultiStepForm />
        </div>
      } />
      <Route path="/signup/role-size" element={
        <div className="min-h-screen bg-white">
          <MultiStepForm />
        </div>
      } />
      <Route path="/signup/platform-setup" element={
        <div className="min-h-screen bg-white">
          <MultiStepForm />
        </div>
      } />
      <Route path="/signup/review" element={
        <div className="min-h-screen bg-white">
          <MultiStepForm />
        </div>
      } />
      <Route path="/signup/success" element={<SuccessPage />} />

      {/* Admin portal routes */}
      <Route path="/admin" element={<AdminPortal />} />
      <Route path="/admin/:networkId" element={<NetworkOnboardingForm />} />

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/signup/personal-info" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <RecaptchaProvider>
      <Router>
        <AppContent />
      </Router>
    </RecaptchaProvider>
  );
}

export default App;
